/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 85f56534b2f4
 */

import { assetsDestroyByAssetId } from "../../funcs/assetsDestroyByAssetId.js";
import { ComponentsDestroyRequest$zodSchema } from "../../models/componentsdestroyrequest.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: ComponentsDestroyRequest$zodSchema.describe(
    `The asset to delete and related options.`,
  ),
};

export const tool$assetsDestroyByAssetId: ToolDefinition<typeof args> = {
  name: "delete-asset",
  description: `Delete asset by asset ID

Deletes an asset using its immutable asset ID.
`,
  scopes: ["admin"],
  annotations: {
    "title": "Delete Asset",
    "destructiveHint": true,
    "idempotentHint": true,
    "openWorldHint": false,
    "readOnlyHint": false,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await assetsDestroyByAssetId(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
